package horcrux.common.extensions

import arrow.core.Either
import arrow.core.left
import arrow.core.right
import arrow.core.toNonEmptySetOrNull
import horcrux.common.types.NonEmptyMap
import horcrux.common.types.NonEmptyMap.Companion.nonEmptyMapOf

fun <A, B> Map<A, B>.toNonEmptyMap(): Either<Throwable, NonEmptyMap<A, B>> =
    this.toList().toNonEmptySetOrNull()?.let { nonEmptyMapOf(it.head, *it.drop(1).toTypedArray()).right() }
        ?: IllegalStateException("Attempted to convert empty list to NonEmptyList").left()
